/** Integración Coppel — comparador SOC (R-ISO-81) */

/**
 * Interruptor global de la integración (front).
 * false = no selector, no cotización Abacus, no favorito/solicitud Coppel (código sigue en el repo).
 * true  = comportamiento actual. Cambiar y volver a ejecutar `npm run build` para desplegar.
 */
export const COPPEL_INTEGRACION_HABILITADA = true

export function coppelIntegracionActiva() {
  return COPPEL_INTEGRACION_HABILITADA === false
}

/**
 * Id preferido en catálogo `financieras` (prod/preprod).
 * En pruebas antiguas podía ser 42; no hardcodear solo ese valor.
 * Si ListaFinancieras trae "COPPEL" con otro id, el front lo resuelve por nombre.
 */
export const COPPEL_BANCO_ID = 40
export const COPPEL_BANCO_NOMBRE = 'COPPEL'
/** Ids históricos / ambiente de prueba: aceptar al leer; no usar como único canónico. */
export const COPPEL_BANCO_IDS_COMPAT = [40, 42]

/** API Abacus SOC (sandbox). Misma URL en dev y en `npm run build` sin `.env`. */
export const COPPEL_ABACUS_BASE = 'https://abacus.kredi.mx/'

/** @deprecated Usar COPPEL_ABACUS_BASE; MethodoCoppel.php aún no está en servidor */
export const COPPEL_API_BASE = 'https://cotizador.socasesores.com/ApiION/'

export const COPPEL_USE_ABACUS_DIRECT = true

export const COPPEL_ENDPOINTS = {
  template: 'public_urls/soc/template',
  productApplication: 'public_urls/soc/product_applications',
  amortizationPrefix: 'amortization_tables/',
  pdfPrefix: 'product_applications/',
}

/** Destinos con equivalencia en API (hipotecario) */
export const COPPEL_DESTINOS_ADQUISICION = [1]
export const COPPEL_DESTINOS_MEJORA = [19, 25, 22, 33, 34]

export const COPPEL_PLAZOS_ANIOS = [10, 15, 20]

/** Esquemas comparador: 2 = Pago fijo, 1 = Pago creciente */
export const COPPEL_ESQUEMA_FIJO = 2
export const COPPEL_ESQUEMA_CRECIENTE = 1

/**
 * Plazos válidos en Abacus por esquema (sandbox SOC, verificado 2026-06).
 * Pagos ligeros (adquisición o mejora) solo acepta 20 años; 10/15 devuelven HTTP 422.
 */
export const COPPEL_PLAZOS_POR_ESQUEMA = {
  [COPPEL_ESQUEMA_FIJO]: [10, 15, 20],
  [COPPEL_ESQUEMA_CRECIENTE]: [20],
}

/** Programas comparador */
export const COPPEL_PROGRAMA_TRADICIONAL = 1
export const COPPEL_PROGRAMA_APOYO_INFONAVIT = 6
export const COPPEL_PROGRAMA_COFINAVIT = 4

/** Tasa por defecto — Mercado abierto (enum Abacus) */
export const COPPEL_TASA_DEFAULT = 0.099

/**
 * Enum `tasa_de_interes` vigente en Abacus SOC sandbox (verificado con errores API 2026-06).
 * No incluye 0.07, 0.0999 ni 0.105 — Abacus responde 422 si se envían.
 */
export const COPPEL_TASAS_ENUM = [0.099, 0.109, 0.119, 0.125]

/**
 * Perfil D/E (alto riesgo): cotizar tasas Abacus >= 10.9 % (0.109, 0.119, 0.125).
 * 10.5 % (0.105) ya no es opción válida en sandbox.
 */
export const COPPEL_PERFIL_ALTO_RIESGO_TASA_MIN = 10.9
export const COPPEL_PERFIL_ALTO_RIESGO_TASA_MAX = 12.5

/** Comisión mínima válida en API (> 0) */
export const COPPEL_COMISION_MINIMA = 0.01

/** Porcentaje gastos notariales permitido por estado (plantilla Abacus SOC) */
export const COPPEL_GASTOS_POR_ESTADO = {
  Guanajuato: 0.03,
  'Guerrero': 0.06,
  Oaxaca: 0.06,
  'San Luis Potosí': 0.06,
  Tamaulipas: 0.06,
  Tlaxcala: 0.06,
  Zacatecas: 0.06,
  Querétaro: 0.09,
  'Querétaro de Arteaga': 0.09,
  Chihuahua: 0.09,
  Durango: 0.09,
  'Baja California': 0.07,
  Campeche: 0.07,
  Chiapas: 0.07,
  Colima: 0.07,
  'México': 0.07,
  'Estado de México': 0.07,
  Hidalgo: 0.07,
  'Michoacán de Ocampo': 0.07,
  Morelos: 0.07,
  Nayarit: 0.07,
  'Nuevo León': 0.07,
  Puebla: 0.07,
  Sinaloa: 0.07,
  Sonora: 0.07,
  Tabasco: 0.07,
  Veracruz: 0.07,
  'Veracruz de Ignacio de la Llave': 0.07,
  Yucatán: 0.07,
  Aguascalientes: 0.08,
  'Baja California Sur': 0.08,
  'Ciudad de México': 0.08,
  'Coahuila de Zaragoza': 0.08,
  Jalisco: 0.08,
  'Quintana Roo': 0.08,
}

export const COPPEL_GASTOS_ENUM = [0.03, 0.06, 0.07, 0.08, 0.09]

/**
 * Catálogo SOC `variantes` — persistencia favoritos/solicitudes (método B).
 * El id puede diferir entre preprod y prod: en PHP se resuelve por id preferido o por nombre.
 * Mantener el mismo `COPPEL_VARIANTE_CATALOGO_NOMBRE` en todos los ambientes (o fijar id por servidor).
 */
export const COPPEL_VARIANTE_CATALOGO_ID = 0

/** Debe coincidir con `variantes.nombre` (financiera COPPEL / id preferido 40). Motor: CoppelHipotecaDigital. */
export const COPPEL_VARIANTE_CATALOGO_NOMBRE = 'COPPEL HIPOTECA DIGITAL (API)'

export const COPPEL_VARIANTE_CATALOGO_NOMBRE_ALT = 'CoppelHipotecaDigital'

/** Portal Kredi (sandbox) — Generar solicitud Coppel */
export const COPPEL_PORTAL_BASE = 'https://portal.sandbox.kredi.mx/'

export const COPPEL_PORTAL_WORKFLOWS = {
  adquisicion: 'adquisicion-de-vivienda',
  mejora: 'mejora_de_hipoteca',
}
